module.exports = __webpack_public_path__ + "img/hero.e84f86f2.png";